import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06a2.5 2.5 0 0 0 2.5 -2.5v-8.5a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2","key":"svg-0"}],["path",{"d":"M7 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M15 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}]]

const IconCardboards = createReactComponent('outline', 'cardboards', 'Cardboards', __iconNode);

export default IconCardboards;